module.exports = __webpack_public_path__ + "img/newImg10.968ce0dc.png";